export default __webpack_public_path__ + "static/media/IMG_00001.af373742.jpeg";